module.exports = __webpack_public_path__ + "img/bg.a659bfcb.png";